import { useState } from 'react';
import { ArrayFieldItemApi, useArrayFieldItemApi } from 'informed';

// types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';
import { AddressAutocomplete } from './AddressAutocomplete';
import { useGoogleMaps } from '../../../../hooks';
import {
  useGoogleAddressOptions,
  GoogleAddressOption,
  isGoogleAddressOption,
} from './useGoogleAddressOptions';

type AddressComponentProps = $TSFixMe;
export const AddressComponent = ({ ...rest }: AddressComponentProps) => {
  const { google, placesLibrary } = useGoogleMaps();
  const [value, setValue] = useState<$TSFixMe>();
  const [inputValue, setInputValue] = useState<$TSFixMe>();
  const arrayFieldItemApi = useArrayFieldItemApi();

  const { options, centreSearchResults, setSessionToken } =
    useGoogleAddressOptions(value || '', google, placesLibrary);

  return (
    <>
      <AddressAutocomplete
        {...rest}
        options={options}
        value={value}
        inputValue={inputValue}
        onFocus={() => {
          centreSearchResults();

          //generate a new session token
          if (placesLibrary?.AutocompleteSessionToken) {
            const newSessionToken =
              new placesLibrary.AutocompleteSessionToken();
            setSessionToken(newSessionToken);
          }
        }}
        getOptionLabel={(option: string | GoogleAddressOption) => {
          return typeof option === 'string' ? option : option.description;
        }}
        onChange={(
          _event: unknown,
          newValue: string | GoogleAddressOption | null,
        ) => {
          if (typeof newValue === 'string') {
            setValue(newValue);
            setInputValue(newValue);
          } else if (isGoogleAddressOption(newValue)) {
            const addressValue = newValue.address || '';
            if (addressValue) {
              setValue(addressValue);
            }

            fillInAddress(newValue, arrayFieldItemApi, (v) => {
              setValue(v);
              setInputValue(v);
            });
          } else if (newValue === null) {
            setValue('');
            setInputValue('');
          }
        }}
        onInputChange={(_: unknown, newInputValue: string) => {
          setInputValue(newInputValue);
          setValue(newInputValue);
        }}
      />
    </>
  );
};

/**
 * Given a place object containing the place_id, fire off a query to Google Maps for details and use those to fill in other relevant fields in the form
 * @param {object} place - The place object from Google Maps containing the place_id
 */
export const fillInAddress = (
  place: GoogleAddressOption,
  arrayFieldItemApi: ArrayFieldItemApi,
  setAddressValue: (address: string) => void,
) => {
  const addressPortion = place.address ?? '';
  [
    ['address', addressPortion],
    ['city', place.city ?? ''],
    ['province', place.province ?? ''],
    ['postal', place.postal ?? ''],
  ].forEach(([apiName, value]) => {
    if (!value) {
      return;
    }
    arrayFieldItemApi.setValue(apiName, value);
    // @ts-expect-error
    arrayFieldItemApi.setTouched(apiName, true);
  });
  setAddressValue(addressPortion);
};
